import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { updateNotificationPreferences } from '../../api/apiNotifications';
import parseError from '../../utils/parseError';

export const useUpdateNotificationPreferences = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateNotificationPreferences,
        onSuccess: () => {
            toast.success(t('profile.preferencesSaved', 'Preferences saved'));
            queryClient.invalidateQueries({ queryKey: ['notification-preferences'] });
        },
        onError: (err) => {
            toast.error(parseError(err) || t('profile.preferencesSaveError', 'Could not save preferences'));
        },
    });
};

export default useUpdateNotificationPreferences;
